/*

Template:  Webmin - Bootstrap 4 & Angular 5 Admin Dashboard Template
Author: potenzaglobalsolutions.com
Design and Developed by: potenzaglobalsolutions.com

NOTE: 

*/

(function($){
"use strict";

$(document).ready(function() {
 /*************************
     Line chart
*************************/ 
if ($('#morris-line').exists()) {


           $.ajax({
                    url: "./ventaslineaGrafica",
                    dataType: "json",
                    data:'',
                    beforeSend: function() {
                        console.log("cargando");
                    },
                    success: function(dataResp) {
                                console.log(dataResp);              
                        
                    }
                });
/*
    Morris.Line({
      element: 'morris-line',
      data: [
        { 'y': '2011', 'Tickets': '50', 'Importe': 40 },
        { 'y': '2012', 'Tickets': '75',  'Importe': 65 },
        { 'y': '2013', 'Tickets': '50',  'Importe': 40 },
        { 'y': '2014', 'Tickets': '75',  'Importe': 65 },
        { 'y': '2015', 'Tickets': '50',  'Importe': 40 },
        { 'y': '2016', 'Tickets': '75',  'Importe': 65 },
        { 'y': '2017', 'Tickets': '60',  'Importe': 50 }
      ],
      xkey: 'y',
      ykeys: ['Tickets', 'Importe'],
      labels: ['Series A', 'Series B'],
      fillOpacity: ['0.1'],
      pointFillColors:['#ffffff'],
      pointStrokeColors:['#999999'],
      behaveLikeLine: true,
      gridLineColor: '#efefef',
      hideHover: 'auto',
      lineWidth: '3px',
      pointSize: 0,
      preUnits: '$',
      resize: true,
      lineColors:['#dc3545 ', '#17a2b8']
    });
*/

Morris.Line({
  element: 'morris-line',
  data: [
    { period: '2016-05-10', park1: 200, park2: 100, park3: 50},
    { period: '2016-05-11', park1: 15, park2: 275, park3: 5},
    { period: '2016-05-12', park1: 80, park2: 20, park3: 30 },
    { period: '2016-05-13', park1: 100, park2: 200, park3: 250},
    { period: '2016-05-14', park1: 50, park2: 60, park3: 20 },
    { period: '2016-05-15', park1: 75, park2: 65, park3: 10 }
  ],
  lineColors: ['#819C79', '#fc8710', '#FF6541'],
  xkey: 'period',
  ykeys: ['park1','park2','park3'],
  labels: ['Importe', '# de tickets', '# de articulos'],
  xLabels: 'day',
  xLabelAngle: 45,
  xLabelFormat: function (d) {
    var weekdays = new Array(7);
    weekdays[0] = "DOM";
    weekdays[1] = "LUN";
    weekdays[2] = "MAR";
    weekdays[3] = "MIE";
    weekdays[4] = "JUE";
    weekdays[5] = "VIE";
    weekdays[6] = "SAB";

    return weekdays[d.getDay()] + '-' + 
           ("0" + (d.getMonth() + 1)).slice(-2) + '-' + 
           ("0" + (d.getDate())).slice(-2);
  },
  resize: true
});



}
  /*************************
     Bar chart
*************************/    
if ($('#morris-bar').exists()) {
    Morris.Bar({
        element: 'morris-bar',
        data: [
            { y: '2012', a: 142,  b: 155 , c: 165 },
            { y: '2013', a: 160,  b: 150 , c: 135 },
            { y: '2014', a: 185,  b: 195 , c: 166 },
            { y: '2015', a: 190, b: 205 , c: 185 },
            { y: '2016', a: 210, b: 180 , c: 175 },
            { y: '2017', a: 190, b: 180 , c: 195 },
            { y: '2018', a: 180, b: 190 , c: 200 }
        ],
        xkey: 'y',
        ykeys: ['a', 'b', 'c'],
        labels: ['WordPress', 'HTML5', 'eCommerce'],
        hideHover: 'auto',
        resize: true,
        gridLineColor: '#efefef',
        barSizeRatio: 0.4,
        xLabelAngle: 35,
        barColors: ['#ffc107','#28a745', '#17a2b8']
    });
}

  /*************************
     Area chart
*************************/   
if ($('#morris-area').exists()) {
    Morris.Area({
            element: 'morris-area',
            pointSize: 0,
            lineWidth: 0,
            data: [
                { y: '2011', a: 50, b: 60 },
                { y: '2012', a: 75,  b: 55 },
                { y: '2013', a: 40,  b: 60 },
                { y: '2014', a: 65,  b: 75 },
                { y: '2015', a: 60,  b: 50 },
                { y: '2016', a: 75,  b: 85 },
                { y: '2017', a: 40, b: 50 },
            ],
            xkey: 'y',
            ykeys: ['a', 'b'],
            labels: ['Series A', 'Series B'],
            hideHover: 'auto',
            resize: true,
            gridLineColor: '#efefef',
            lineColors: ['#17a2b8', "#e6e6e6"]
        });
}
/*************************
     Bar chart stacked
*************************/  
if ($('#morris-bar-stacked').exists()) {
    Morris.Bar({
            element: 'morris-bar-stacked',
            data: [
                { y: '2011', a: 90,  b: 70, c: 65 },
                { y: '2012', a: 85,  b: 65, c: 46 },
                { y: '2013', a: 60,  b: 50, c: 47 },
                { y: '2014', a: 85,  b: 75, c: 90 },
                { y: '2015', a: 90, b: 110, c: 123 },
                { y: '2016', a: 100, b: 85, c: 75 },
                { y: '2017', a: 85, b: 120, c: 110 },
                { y: '2018', a: 65,  b: 85, c: 70 },
            ],
            xkey: 'y',
            ykeys: ['a', 'b', 'c'],
            stacked: true,
            labels: ['Amazon', 'Ebay','Wallmart'],
            hideHover: 'auto',
            resize: true, //defaulted to true
            gridLineColor: '#efefef',
            barColors: ['#84ba3f','#17a2b8', '#e6e6e6']
        });
    }
/*************************
    Area chart with point
*************************/  
if ($('#morris-area-dotted').exists()) {
    Morris.Area({
            element: 'morris-area-dotted',
            pointSize: 3,
            lineWidth: 1,
            data: [
                { y: '2011', a: 30, b: 40 },
                { y: '2012', a: 55,  b: 60 },
                { y: '2013', a: 60,  b: 50 },
                { y: '2014', a: 70,  b: 65 },
                { y: '2015', a: 50,  b: 60 },
                { y: '2016', a: 55,  b: 75 },
                { y: '2017', a: 80, b: 70 }
            ],
            xkey: 'y',
            ykeys: ['a', 'b'],
            labels: ['Series A', 'Series B'],
            hideHover: 'auto',
            pointFillColors: ['#ffffff'],
            pointStrokeColors: ['#999999'],
            resize: true,
            smooth: false,
            gridLineColor: '#efefef',
            lineColors: ['#17a2b8', "#e6e6e6"]
        });
}
/*************************
    Donut chart
*************************/  
if ($('#morris-donut').exists()) {
        Morris.Donut({
                element: 'morris-donut',
                data: [
                    {label: "FINANCIAL", value: 65},
                    {label: "MARKETS", value: 150},
                    {label: "ELECTRICITY", value: 120}
                ],
                resize: true,
                colors: ['#84ba3f', '#17a2b8', "#ffc107"]
            });
}
});
})(jQuery);